import { Component, OnInit, inject, ChangeDetectorRef, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProfileService } from '../../../core/services/profile.service';
import { UserProfile } from '../../../core/models/user-profile.model';
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss'
})
export class MyProfileComponent implements OnInit {
  private profileService = inject(ProfileService);
  private alertService = inject(AlertService);
  private cdr = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);

  user: UserProfile & { password?: string } = {
    name: '',
    phone: '',
    email: '',
    description: null,
    address: null,
    secondPhone: null,
    workingHours: null,
    logo: null,
    gallery: null,
    packetId: null,
    password: ''
  };

  showPassword = false;
  showDeleteModal = false;

  get initials(): string {
    if (!this.user.name) return '';
    return this.user.name.charAt(0).toUpperCase();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadProfile();
    }
  }

  loadProfile(): void {
    this.profileService.getMe().subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.user = { ...this.user, ...res.data };
          // Yüklənmiş nömrəni formatlayırıq
          if (this.user.phone) {
            this.formatLoadedPhone(this.user.phone);
          }
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error('Profil yüklənərkən xəta baş verdi:', err);
      }
    });
  }

  private formatLoadedPhone(phone: string): void {
    let digits = phone.replace(/\D/g, '');
    if (digits.startsWith('994')) {
      digits = digits.substring(3);
    }
    digits = digits.substring(0, 9);

    if (digits.length > 0) {
      let formattedValue = '+994 (' + digits.substring(0, 2);
      if (digits.length > 2) {
        formattedValue += ') ' + digits.substring(2, 5);
        if (digits.length > 5) {
          formattedValue += '-' + digits.substring(5, 7);
          if (digits.length > 7) {
            formattedValue += '-' + digits.substring(7, 9);
          }
        }
      }
      this.user.phone = formattedValue;
    }
  }

  onPhoneInput(event: any): void {
    const input = event.target;
    let value = input.value;
    const selectionStart = input.selectionStart;
    const oldLength = value.length;

    let digits = value.replace(/\D/g, '');

    if (digits.startsWith('994')) {
      digits = digits.substring(3);
    }

    digits = digits.substring(0, 9);

    let formattedValue = '';
    if (digits.length > 0) {
      formattedValue = '+994 (' + digits.substring(0, 2);
      if (digits.length > 2) {
        formattedValue += ') ' + digits.substring(2, 5);
        if (digits.length > 5) {
          formattedValue += '-' + digits.substring(5, 7);
          if (digits.length > 7) {
            formattedValue += '-' + digits.substring(7, 9);
          }
        }
      }
    } else {
      formattedValue = '';
    }

    this.user.phone = formattedValue;

    setTimeout(() => {
      const newLength = formattedValue.length;
      let newSelection = selectionStart + (newLength - oldLength);
      input.setSelectionRange(newSelection, newSelection);
    }, 0);
  }

  saveProfile() {
    if (!this.user.name || this.user.name.length < 3) {
      this.alertService.error('Zəhmət olmasa adınızı düzgün daxil edin');
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.user.email && !emailRegex.test(this.user.email)) {
      this.alertService.error('Zəhmət olmasa düzgün e-poçt ünvanı daxil edin');
      return;
    }

    const phoneDigits = this.user.phone ? this.user.phone.replace(/\D/g, '') : '';
    if (phoneDigits.length !== 12) { // 994 + 9 digits
      this.alertService.error('Zəhmət olmasa telefon nömrəsini tam daxil edin');
      return;
    }

    const profileToUpdate = { ...this.user };
    if (!profileToUpdate.password) {
      delete profileToUpdate.password;
    }
    this.profileService.updateProfile(profileToUpdate).subscribe({
      next: (res) => {
        if (res.success) {
          this.alertService.success('Profil məlumatları yeniləndi!');
        } else {
          this.alertService.error('Profil yenilənərkən xəta baş verdi.');
        }
      },
      error: (err) => {
        this.alertService.error('Sistem xətası baş verdi.');
        console.error(err);
      }
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  confirmDelete() {
    this.showDeleteModal = true;
  }

  closeModal() {
    this.showDeleteModal = false;
  }
}
